import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import { IconPointFilled, IconSparkleHighlight } from '@tabler/icons-react'
import { DashboardCardWrapper } from '../../commonComponents/DashboardCardWrapper'

export const SalesStatusCard = () => {

    const salesStatus = [
        { percentage: "70%", label: "Paid", color: "green" },
        { percentage: "20%", label: "Pending", color: '#e4e400' },
        { percentage: "10%", label: "Cancelled", color: 'red' },
    ]
    return (
        <DashboardCardWrapper
            headerText={"Sales Status"}
            headerSubtext={"Your total sales count."}
            headerIcon={<IconSparkleHighlight color={"#7a3a5e"} stroke={2} />}
            componentClassname={" "}
            componentStyles={{ height: "20rem", width: "100%" }}
        >
            <div
                className="w-100 d-flex overflow-hidden mt-3 position-relative shadow-sm border border-light-subtle"
                style={{ height: "2.5rem", backgroundColor: "#f8fafc", borderRadius: "8px" }}
            >
                {salesStatus?.length > 0 ? (
                    <>
                        <Tooltip
                            title="Paid - 70%"
                            placement='top'
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        fontSize: "0.8rem",
                                        backgroundColor: "white",
                                        border: '1px solid #efefef',
                                        color: "black",
                                        fontWeight: 700,
                                        boxShadow: "0 6px 18px rgba(0, 0, 0, 0.18)"
                                    },
                                },
                            }}
                        >
                            <div
                                className=" position-relative"
                                style={{
                                    width: "70%",
                                    background: "linear-gradient(90deg, #a7f3d0 0%, #10b981 100%)",
                                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
                                }}
                            />
                        </Tooltip>
                        <Tooltip
                            title="Pending - 20%"
                            placement='top'
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        fozntSize: "0.8rem",
                                        backgroundColor: "white",
                                        border: '1px solid #efefef',
                                        color: "black",
                                        fontWeight: 700,
                                        boxShadow: "0 6px 18px rgba(0, 0, 0, 0.18)"
                                    },
                                },
                            }}
                        >
                            <div
                                className="position-relative"
                                style={{
                                    width: "20%",
                                    background: "linear-gradient(90deg, #fef08a 0%, #eab308 100%)",
                                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
                                }}
                            />
                        </Tooltip>
                        <Tooltip
                            title="Cancelled - 10%"
                            placement='top'
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        fontSize: "0.8rem",
                                        backgroundColor: "white",
                                        border: '1px solid #efefef',
                                        color: "black",
                                        fontWeight: 700,
                                        boxShadow: "0 6px 18px rgba(0, 0, 0, 0.18)"
                                    },
                                },
                            }}
                        >
                            <div
                                className="position-relative"
                                style={{
                                    width: "10%",
                                    background: "linear-gradient(90deg, #fecaca 0%, #ef4444 100%)",
                                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
                                }}
                            />
                        </Tooltip>
                    </>
                ) : (
                    <div className="w-100 bg-light-subtle" style={{ opacity: 0.5 }} />
                )}
            </div>
            {
                salesStatus?.map((c, idx) => {
                    return <>
                        <div key={idx} className='d-flex-column gap-2 ' style={{ bottom: 35, right: 20 }}>
                            <div className="d-flex align-items-center justify-content-between py-2">
                                <div className="d-flex align-items-center text-dark" style={{ fontSize: '0.875rem', fontWeight: "500" }}>
                                    <IconPointFilled size={15} style={{ color: c.color }} className='me-1 flex-shrink-0 ' />
                                    <span>{c.label}</span>
                                </div>
                                <span className="fw-semibold text-dark" style={{ fontSize: "13px" }}>{c.percentage}</span>
                            </div>
                        </div>
                    </>
                })
            }
        </DashboardCardWrapper>
    )
}
